import React from "react";
import { Row, Col } from "antd";
import { useTranslation, Trans } from "react-i18next";
import darkImg from "../../../../assets/images/survey-dark-theme.png";
import lightImg from "../../../../assets/images/survey-light-theme.png";

import "../../../../assets/survey.scss";

const SurveyStepThreeRender = ({ handleChangeChooseList, stepThreeChooseList }) => {
  const { t } = useTranslation(["loginAndSignUp"]);

  return (
    <div className="step-three-cont">
      <div className="mb-5 step-cont-title pb-0 pb-md-4">
        <Trans i18nKey="loginAndSignUp:surveyStep3">
          Text
          <span className="text-primary step-cont-number fw-bolder">Text </span>
          Text
        </Trans>{" "}
        {t("surveyThemeQuestion")}
      </div>
      <Row gutter={[16, 28]}>
        <Col span={24} md={12}>
          <div
            onClick={() => handleChangeChooseList("light")}
            className={`d-flex flex-column align-items-center justify-content-center position-relative ${
              stepThreeChooseList.indexOf("light") !== -1 ? "active" : ""
            }`}
          >
            <img className="mw-100" src={lightImg} alt="light" />
            <span>{t("surveyAnswerLightMode")}</span>
          </div>
        </Col>
        <Col span={24} md={12}>
          <div
            onClick={() => handleChangeChooseList("dark")}
            className={`d-flex flex-column align-items-center justify-content-center position-relative ${
              stepThreeChooseList.indexOf("dark") !== -1 ? "active" : ""
            }`}
          >
            <img className="mw-100" src={darkImg} alt="dark" />
            <span>{t("surveyAnswerDarkMode")}</span>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SurveyStepThreeRender;
